import { parseDocumentCategory } from '../../shared/helpers/documents.func';
import { ApiDocumentEntry, ApiDocumentFile, ApiBatchDocumentFile } from '../api-types/document.api';
import { DocumentEntry, DocumentFile } from '../app-types/document.app';

/**
 * Transforms an API document file to an application document file.
 * @param input The API document file to transform.
 * @returns The transformed application document file.
 */
export const transformApiDocumentFileToAppDocumentFile = (input: ApiDocumentFile): DocumentFile => {
	return {
		id: input.fileId,
		name: input.fileName,
		location: input.url,
		mimeType: input.mimeType,
		size: input.fileByteLength,
		isFrozen: input.isFrozen,
		createdAt: input.createdAt ? new Date(input.createdAt) : undefined,
	};
};

export const transformApiDocumentFilesToAppDocumentFiles = (input: ApiDocumentFile[]): DocumentFile[] => {
	return (input ?? []).map(transformApiDocumentFileToAppDocumentFile);
};

export const transformApiBatchDocumentFileToAppDocumentFile = (input: ApiBatchDocumentFile): DocumentFile => {
	return {
		id: input.guidId,
		name: input.fileName,
		location: '',
		mimeType: '',
		size: 0,
	};
};

export const transformApiBatchDocumentFilesToAppDocumentFiles = (input: ApiBatchDocumentFile[]): DocumentFile[] => {
	return (input ?? []).map(transformApiBatchDocumentFileToAppDocumentFile);
};

export const transformAppDocumentFileToApiDocumentFile = (input: DocumentFile): ApiDocumentFile => {
	return {
		fileId: input.id,
		fileName: input.name,
		url: input.location,
		mimeType: input.mimeType,
		fileByteLength: input.size,
		isFrozen: input.isFrozen ?? false,
	};
};

export const transformAppDocumentFilesToApiDocumentFiles = (input: DocumentFile[]): ApiDocumentFile[] => {
	return (input ?? []).map(transformAppDocumentFileToApiDocumentFile);
};

export const transformApiDocumentEntryToAppDocumentEntry = (input: ApiDocumentEntry): DocumentEntry => {
	return {
		id: input.id,
		name: input.name ?? '',
		category: parseDocumentCategory(input.category),
		createdAt: new Date(input.createdAt),
		externalFileReference: transformApiDocumentFilesToAppDocumentFiles(input.externalFileReference) ?? [],
		isReport: input.isReport,
		isFrozen: input.isFrozen,
		assignmentId: input.assignmentId,
		reportTypeId: input.categoryReportId,
	};
};

export const transformApiDocumentEntriesToAppDocumentEntries = (input: ApiDocumentEntry[]): DocumentEntry[] => {
	return input.map(transformApiDocumentEntryToAppDocumentEntry);
};
